


















































import { Component, Vue } from 'vue-property-decorator'
import { SettingsStoreModule as settingsStore } from '@/shared/config/store/settings-store'
import ThemePicker from '@/shared/components/ThemePicker/index.vue'

@Component({
  name: 'Settings',
  components: {
    ThemePicker
  }
})
export default class extends Vue {
  get fixedHeader() {
    return settingsStore.fixedHeader
  }

  set fixedHeader(value) {
    settingsStore.ChangeSetting({ key: 'fixedHeader', value })
  }

  get showTagsView() {
    return settingsStore.showTagsView
  }

  set showTagsView(value) {
    settingsStore.ChangeSetting({ key: 'showTagsView', value })
  }

  get showSidebarLogo() {
    return settingsStore.showSidebarLogo
  }

  set showSidebarLogo(value) {
    settingsStore.ChangeSetting({ key: 'showSidebarLogo', value })
  }

  get sidebarTextTheme() {
    return settingsStore.sidebarTextTheme
  }

  set sidebarTextTheme(value) {
    settingsStore.ChangeSetting({ key: 'sidebarTextTheme', value })
  }

  private themeChange(value: string) {
    settingsStore.ChangeSetting({ key: 'theme', value })
  }
}
